// extracted by mini-css-extract-plugin
module.exports = {"phonePreviewContainer":"PhonePreview_phonePreviewContainer__3uuUb","phonePreview":"PhonePreview_phonePreview__27bI8"};